
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50 border-b border-gray-100">
      <nav className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-black rounded-lg flex items-center justify-center">
                <i className="ri-brush-line text-white text-xl"></i>
              </div>
              <span className="text-2xl font-bold text-black tracking-tight">SA House Painters</span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:block">
            <div className="flex items-center space-x-8">
              <Link to="/" className="text-base font-medium transition-colors whitespace-nowrap cursor-pointer text-black">
                Home
              </Link>

              <Link to="/quote" className="text-base font-medium transition-colors whitespace-nowrap cursor-pointer text-gray-600 hover:text-black">
                Request a Quote
              </Link>
            </div>
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Link to="/find-painters" className="bg-lime-400 text-black px-6 py-3 rounded-lg text-base font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer shadow-sm">
              Find Painters
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg-hidden">
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-600 hover:text-black hover:bg-gray-100 cursor-pointer"
            >
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden border-t border-gray-100 py-4">
            <div className="space-y-4">
              <Link to="/" className="block text-base font-medium text-black">Home</Link>
              <Link to="/quote" className="block text-base font-medium text-gray-600">Request a Quote</Link>
              <Link to="/find-painters" className="block bg-lime-400 text-black px-4 py-2 rounded-lg font-semibold text-center">
                Find Painters
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}